import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  taxTrait: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  TAX_TRAIT_SET_LIST(state, list) {
    state.taxTrait.list = list;
  },
  TAX_TRAIT_SET_LIST_LOADING(state, isLoading) {
    state.taxTrait.listLoading = isLoading;
  },
};

export const getters = {
  getTaxTraitsList: state => state.taxTrait.list,
  getTaxTraitsListIsLoading: state => state.taxTrait.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callTaxTraitImportCSV({ dispatch }, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/import/csv`, formData, {
      timeout: 3 * 60 * 1000,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  fetchTaxTraitList({ commit }) {
    commit('TAX_TRAIT_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { taxTraits } = response;
          commit('TAX_TRAIT_SET_LIST_LOADING', false);
          commit('TAX_TRAIT_SET_LIST', taxTraits);
        });
      })
      .catch((error) => {
        commit('TAX_TRAIT_SET_LIST_LOADING', false);
        commit('TAX_TRAIT_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchTaxTraitAll({ dispatch }) {
    dispatch('fetchTaxTraitList');
  },
  createTaxTrait({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait`, payload)
      .then((data) => {
        dispatch('fetchTaxTraitAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updateTaxTrait({ dispatch }, payload) {
    const userId = payload.user_id;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/${userId}`, payload)
      .then((data) => {
        dispatch('fetchTaxTraitAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  deleteTaxTrait({ dispatch }, userId) {
    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/${userId}`)
      .then((data) => {
        dispatch('fetchTaxTraitAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  createTaxTraitDocument({ dispatch }, data) {
    const { taxTraitId, payload } = data;

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/${taxTraitId}/document`, payload)
      .then((response) => {
        dispatch('fetchTaxTraitAll');

        return response;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updateTaxTraitDocument({ dispatch }, data) {
    const { taxTraitId, payload } = data;
    const { id } = payload;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/${taxTraitId}/document/${id}`, payload)
      .then((response) => {
        dispatch('fetchTaxTraitAll');

        return response;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  deleteTaxTraitDocument({ dispatch }, data) {
    const { taxTraitId, documentId } = data;

    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/${taxTraitId}/document/${documentId}`)
      .then((response) => {
        dispatch('fetchTaxTraitAll');

        return response;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const taxTrait = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default taxTrait;



// WEBPACK FOOTER //
// ./src/store/payout/taxTrait.js